var en_us = {
    values: {
        'Export settings': 'Export settings',
        'Import settings': 'Import settings',
        export: 'export',
        Enabled: 'Enabled',
        Disabled: 'Disabled',
        Export: 'Export',
        'Export-noun': 'Export',
        Import: 'Import',
        import: 'import',
        Connection: 'Connection',
        'Fetch Interval': 'Fetch Interval',
        'Retry Interval': 'Retry Interval',
        Identification: 'Identification',
        'SAMTER Standard Channels': 'SAMTER Standard Channels',
        'SAMTER Standard Channel': 'SAMTER Standard Channel',
        'Property to import': 'Property to import',
        'Choose a property': 'Choose a property',
        Wells: 'Wells',
        Well: 'Well',
        'New well': 'New well',
        'New Well': 'New Well',
        'New well to import': 'New well to import',
        Next: 'Next',
        'Total Configured channels': 'Total Configured channels',
        'Interval between events': 'Interval between events',
        'You need to inform Connection credentials and set the "SAMTER Standard Channels" before add new wells.':
            'You need to inform Connection credentials before add new wells.',
        'Well name is required': 'Well name is required',
        Mnemonic: 'Mnemonic'
    }
}

module.exports = en_us
